import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';

export const TEMPLATE_SCHEMA = Object.freeze({
    STYLE: '',
    BACKGROUND: '',
    HEADER: '',
    COLOR: '',
  }),
  RECORD = generateSchema(TEMPLATE_SCHEMA),
  KEYS: any = generateKeys(TEMPLATE_SCHEMA);

export class Template extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get style(): string {
    return this.get(KEYS.STYLE);
  }

  get header(): string {
    return this.get(KEYS.HEADER);
  }

  get background(): string {
    return this.get(KEYS.BACKGROUND);
  }

  get color(): string {
    return this.get(KEYS.COLOR);
  }
}
